{
  "app": {
    "logoTitle": "OnCore Integration Service",
    "logoSubtitle": "Technology and Digital Solutions",
    "copyrightYear": "2026",
    "supportEmail": ""
  },
  "ois": {
    "filter": {
      "label": {
        "action": "Action:",
        "selectAction": "Select Action"
      }
    },
    "table": {
      "title": "Recent Activity",
      "columnName": {
        "fileName": "File Name",
        "source": "Source",
        "type": "Type",
        "fileType": "File Type",
        "environment": "Environment",
        "status": "Status",
        "records": "Records",
        "failed": "Failed",
        "uploadedBy": "Uploaded By",
        "uploadedDate": "Uploaded Date"
      },
      "statusIcons": {
        "finished": "Finished",
        "uploaded": "Uploaded",
        "parsed": "Parsed",
        "processing": "Processing",
        "failed": "Failed",
        "incomplete": "Incomplete"
      },
      "filter": {
        "participantRegistration": "participant-registration",
        "continuingReview": "continuing-review",
        "trainingData": "training-data"
      },
      "noRows": "No Recent Activity"
    },
    "dialog": {
      "recentActivityErrors": {
        "title": {
          "info": "Info:"
        },
        "label": {
          "transactions": "Transaction Type:",
          "file": "File Name:",
          "errors": "Errors:",
          "noErrors": "No Errors",
          "messages": "Messages:",
          "noMessages": "No Messages",
          "warnings": "Warnings:",
          "noWarnings": "No Warnings"
        }
      }
    },
    "upload": {
      "dropFile": "Drop the file here ...",
      "dragDrop": "Drag 'n' drop CSV file here, or click to select the file",
      "note": " (Note: Only *.csv files are accepted)",
      "fileUploaded": "File uploaded: "
    },
    "actions": {
      "downloadFailed": "failed-file"
    }
  },
  "eProtocol": {
    "table": {
      "title": "Extracted eProtocol Data",
      "columnName": {
        "protocolNumber": "Protocol Number",
        "reviewDate": "Review Date",
        "submitDate": "Submit Date",
        "actionDate": "Action Date",
        "eventDate": "Event Date",
        "reviewReason": "Review Reason",
        "reviewType": "Review Type",
        "action": "Action",
        "expirationDate": "Expiration Date",
        "institution": "Institution",
        "irbCommittee": "IRB Committee"
      },
      "noRows": "No eProtocol data found for the date range provided"
    },
    "label": {
      "startDate": "Start Date",
      "endDate": "End Date"
    },
    "tooltip": {
      "extract": "Extract from eProtocol",
      "export": "Export extracted eProtocol data into CSV file"
    }
  },
  "csv": {
    "table": {
      "columnName": {
        "context": "Context",
        "protocolNumber": "Protocol Number",
        "studySite": "Study Site",
        "mrn": "MRN",
        "race": "Race",
        "firstName": "First Name",
        "lastName": "Last Name",
        "middleName": "Middle Name",
        "suffix": "Suffix",
        "birthDate": "Birth Date",
        "gender": "Gender",
        "ethnicity": "Ethnicity",
        "approximateBirthDateFlag": "Approximate Birth Date Flag",
        "birthDateNotAvailableFlag": "Birth Date Not Available Flag",
        "approximateExpiredDateFlag": "Approximate Expired Date Flag",
        "expiredDate": "Expired Date",
        "zipAtRegistration": "ZIP At Registration",
        "protocolNo": "Protocol No",
        "organizationalUnit": "Organizational Unit",
        "department": "Department",
        "library": "Library",
        "irbNumber": "IRB No",
        "title": "Title",
        "estimatedCompletionDate": "Estimated Completion Date",
        "involvesTherapy": "Involves Therapy",
        "summaryAccrualInfoOnly": "Summary Accrual Info Only",
        "protocolType": "Protocol Type",
        "managementGroup": "Management Group",
        "staffPd": "Staff Pd",
        "staffPrimaryCrc": "Staff Primary CRC",
        "institutionSites": "Institution Sites"
      },
      "noRows": "No CSV data found"
    }
  },
  "uploadToOnCore": {
    "title": "Upload Above Data to OnCore",
    "dialog": {
      "message": {
        "eProtocol": "Continue Review file ready to parse & upload to OnCore {{environment}} environment.",
        "participants": "Participant Load file ready to parse & upload to OnCore {{environment}} environment.",
        "training": "Training Data file ready to parse & upload to OnCore {{environment}} environment."
      }
    },
    "label": {
      "selectOnCoreEnvironment": "Select OnCore Environment"
    },
    "tooltip": {
      "upload": "Upload data to OnCore"
    }
  },
  "importTypes": {
    "participant-registration": "Participant Registration",
    "continuing-review": "Continuing Review",
    "training-data": "Protocol Data"
  },
  "fileTypes": {
    "text/csv": "CSV"
  },
  "oncoreInstances": {
    "test": "Test",
    "production": "Production",
    "tango": "Tango",
    "indigo": "Indigo",
    "staging": "Staging",
    "shadow": "Shadow",
    "training": "Training",
    "cloudproduction": "Cloud Production"
  },
  "importStatus": {
    "uploaded": "Uploaded",
    "parsed": "Parsed",
    "processing": "Processing",
    "imported": "Imported",
    "failed": "Failed",
    "finished": "Finished",
    "deleting": "Deleting",
    "incomplete": "Incomplete"
  },
  "importSource": {
    "file-upload": "File Upload",
    "json-upload": "Data Upload"
  },
  "csvTypes": {
    "eProtocol": "eProtocol",
    "participants": "participants",
    "training": "training"
  },
  "buttons": {
    "standard": {
      "close": "Close",
      "extract": "Extract",
      "export": "Export",
      "upload": "Upload",
      "cancel": "Cancel",
      "ok": "Ok"
    },
    "caps": {
      "close": "CLOSE",
      "extract": "EXTRACT",
      "export": "EXPORT",
      "upload": "UPLOAD",
      "cancel": "CANCEL",
      "ok": "OK"
    }
  },
  "messages": {
    "info": {
      "api": {
        "downloadFileProcessing": "Export to Excel download request is being processed. The report will be downloaded upon completion of this processing."
      }
    },
    "warning": {
      "api": {
        "userFriendlyError": "Trouble communicating with the server. Please try again in a few minutes. If this problem persists, contact support to open a ticket.",
        "OISMetaNotFound": "[WARN] Empty 200 response from /ois/metadata! Unable to fetch OIS metadata.",
        "OISDataFailed": "[WARN] Empty 200 response from /imports/! Unable to get recent activity records!",
        "eProtocolActivityFailed": "[WARN] Empty 200 response from /eprotocol/activity! Unable to get eProtocol activity!",
        "uploadEnvironmentsFailed": "[WARN] Empty 200 response from /upload-environments! Unable to get upload environments!",
        "uploadToOnCoreFailed": "[WARN] Non-200 response from OnCore upload API! Unable to upload file!",
        "downloadFileFailed": "[WARN] Error downloading file! Unable to process download request!"
      }
    },
    "error": {
      "api": {
        "OISMetaNotFound": "[ERROR] Unable to fetch OIS metadata!",
        "OISDataFailed": "[ERROR] Unable to get recent activity records!",
        "eProtocolActivityFailed": "[ERROR] Unable to get eProtocol activity!",
        "uploadEnvironmentsFailed": "[ERROR] Unable to get upload environments!",
        "uploadToOnCoreFailed": "[ERROR] Unable to upload file to OnCore!",
        "downloadFileFailed": "[ERROR] Unable to download file!"
      }
    }
  }
}
